<template>
  <div class="animated fadeIn">
    <notifications group="error" position="top center" class="mt-1" />
    <notifications group="success" position="top left" class="mt-1" />
    <notifications group="info" position="top left" class="mt-1" />
    <notifications group="warn" position="top left" class="mt-1" />

    <v-card
      class="common-card"
      v-if="$router.currentRoute.path == '/shop/customers'"
      header-bg-variant="primary"
      header-text-variant="white"
    >
      <div class="d-flex flex-row">
        <v-row>
          <v-col cols="12">
            <h4 class="c-grey">مدیریت مشتری‌ها</h4>
          </v-col>
          <v-col cols="12">
            <div class="custom-input2">
              <v-text-field
                hide-details
                outlined
                dense
                label="جستجو ..."
                @input="currentPage = 1"
                v-model="filter"
                placeholder="جستجو"
                prepend-icon="$Search"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="filter.length"
                    class="red--text text--lighten-2"
                    @click="
                      filter = '';
                      currentPage = 1;
                    "
                    >mdi-close-circle</v-icon
                  >
                </template>
              </v-text-field>
            </div>
          </v-col>
        </v-row>
      </div>
      <hr class="mt-3" />
      <v-card v-if="cardLoading" flat>
        <div class="d-flex flex-column align-items-center mt-8 py-6">
          <cube></cube>
          <p class="c-purple font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
      </v-card>
      <v-card v-else flat>
        <v-container>
          <v-row>
            <v-col class="d-flex flex-row" cols="12" sm="6">
              <h4 class="c-purple">مشتریان فروشگاه</h4>
              <span style="padding-top: 2px" class="c-grey ms-4">
                ({{ computedItems.length }} مشتری)
              </span>
            </v-col>
            <v-col class="text-md-left text-sm-right">
              <v-btn
                @click="showNewCustomerDialog()"
                @shortkey="showNewCustomerDialog()"
                v-shortkey.once="['n']"
                class="purple-borderedBtn"
                height="43"
              >
                <v-icon class="me-1">$Bag</v-icon> افزودن مشتری جدید
              </v-btn>
            </v-col>
          </v-row>
          <hr />
          <vue-excel-xlsx
            :data="computedItems"
            :columns="excelFields"
            :file-name="`مشتریان فروشگاه`"
            :sheet-name="'مشتریان فروشگاه'"
            class="darkGreen-mainBtn mb-4 float-start"
            style="width: 135px; height: 35px"
            depressed
            :class="computedItems.length ? 'white--text' : 'disabled-excel'"
          >
            <v-icon
              :class="computedItems.length ? 'white--text' : ''"
              class="me-1"
              >mdi-file-excel-outline</v-icon
            >
            خروجی اکسل
          </vue-excel-xlsx>

          <v-btn
            :disabled="!computedItems.length"
            class="darkRed-mainBtn white--text mb-4 float-end"
            style="width: 135px; height: 35px"
            @click="printReceipt()"
            depressed
            ><v-icon class="me-1">mdi-printer</v-icon> پرینت</v-btn
          >

          <div class="custom-table mt-3">
            <b-table
              responsive
              show-empty
              :current-page="currentPage"
              :per-page="perPage"
              :items="computedItems"
              :fields="fields"
              empty-filtered-text="جستجو نتیجه‌ای در بر نداشت"
              empty-text="رکوردی برای نمایش وجود ندارد."
              striped
              thead-class="headClass"
              tbody-class="bodyClass"
              :filter="userInput"
              id="customers-tabel"
            >
              <template v-slot:empty>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  رکوردی برای نمایش وجود ندارد.
                </div>
              </template>
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:cell(index)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>

              <template v-slot:cell()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <!-- <template v-slot:cell(royaltyTier)="data">
                <div style="text-align: center; vertical-align: middle">
                  <img
                    v-if="data.item.royaltyTier"
                    :src="computedIcon(data.item)"
                    style="height: 26px; width: 26px"
                    class="me-1"
                  />
                  {{
                    data.value == "coper"
                      ? "برنزی"
                      : data.value == "silver"
                      ? "نقره‌ای"
                      : data.value == "gold"
                      ? "طلایی"
                      : data.value == "diamond"
                      ? "الماس"
                      : "-"
                  }}
                </div>
              </template> -->

              <!-- <template v-slot:cell(royaltyCreditType)="data">
                <div style="text-align: center; vertical-align: middle">
                  {{
                    data.value == "normal"
                      ? "معمولی"
                      : data.value == "vip"
                      ? "ویژه"
                      : "فاقد اعتبار"
                  }}
                </div>
              </template> -->

              <template v-slot:cell(operation)="row">
                <div
                  style="text-align: center; vertical-align: middle"
                  class="pt-0"
                >
                  <v-btn
                    v-if="!row.item._showDetails"
                    @click="row.toggleDetails"
                    class="purple-mainBtn"
                    width="120"
                    >نمایش عملیات</v-btn
                  >
                  <v-btn
                    v-else
                    @click="row.toggleDetails"
                    class="red-mainBtn"
                    width="120"
                    >بستن عملیات</v-btn
                  >
                </div>
              </template>
              <template #row-details="row">
                <div
                  class="animated fadeIn mb-2"
                  style="text-align: center; vertical-align: middle"
                >
                  <v-btn
                    :to="'/shop/customer/' + row.item.id"
                    class="purple-mainBtn ms-2 me-2"
                    width="155"
                    height="40"
                    style="text-decoration: none"
                    ><v-icon class="me-1">mdi-eye</v-icon>مشاهده پروفایل</v-btn
                  >
                  <v-btn
                    class="green-mainBtn ms-2 me-2"
                    width="155"
                    height="40"
                    @click="showCustomerDialog(row.item.id)"
                    ><v-icon class="me-1">mdi-pencil-box-outline</v-icon
                    >ویرایش</v-btn
                  >
                </div>
              </template>
            </b-table>
            <v-row class="mt-6">
              <v-col>
                <v-col class="d-flex flex-row">
                  <span class="c-grey pt-2">نمایش در هر صفحه</span>
                  <div class="ms-3 me-3 number-box-new">
                    <v-select
                      attach
                      class="shop-select"
                      :menu-props="{ bottom: true, offsetY: true }"
                      outlined
                      dense
                      v-model="perPage"
                      :items="perPageOptions"
                      @change="currentPage = 1"
                    ></v-select>
                  </div>
                </v-col>
              </v-col>
              <v-col>
                <div>
                  <v-pagination
                    v-model="currentPage"
                    :length="Math.ceil(computedItems.length / perPage)"
                    :total-visible="5"
                    prev-icon="$ArrowLeft"
                    next-icon="$ArrowRight"
                    class="float-end"
                  ></v-pagination>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-card>
    </v-card>

    <v-dialog v-model="customerDialog" width="600px">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey">ویرایش مشتری</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="customerDialog = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <div
          class="d-flex flex-column align-items-center mt-8 py-6"
          v-if="loading"
        >
          <cube></cube>
          <p class="c-purple font-weight-bold mt-4">
            در حال بارگذاری اطلاعات...
          </p>
        </div>
        <div v-else>
          <v-card-text class="custom-input">
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="نام مشتری*"
                  v-model="customer.name"
                  hide-details
                ></v-text-field
              ></v-col>
              <v-col cols="12">
                <v-select
                  attach
                  class="shop-select"
                  :menu-props="{ bottom: true, offsetY: true }"
                  label="نوع مشتری*"
                  :items="customerTypes"
                  v-model="customer.type"
                  outlined
                  dense
                  hide-details
              /></v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="موبایل"
                  v-model="customer.mobile"
                  type="number"
                  hide-details=""
                ></v-text-field>
                <phoneNumber :number="customer.mobile" v-slot="{ isValid }">
                  <div
                    v-if="!isValid"
                    style="vertical-align: middle"
                    class="text--right"
                  >
                    <v-icon class="red--text me-1"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span class="red--text">شماره موبایل معتبر نیست</span>
                  </div>
                </phoneNumber>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="کد اقتصادی"
                  v-model="customer.economicCode"
                  hide-details
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="تلفن"
                  type="number"
                  v-model="customer.phone"
                  hide-details
                ></v-text-field
              ></v-col>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="آدرس"
                  v-model="customer.address"
                  hide-details
                ></v-text-field
              ></v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <v-text-field
                  outlined
                  dense
                  label="کد ملی"
                  type="number"
                  v-model="customer.natCode"
                  hide-details=""
                  :rules="customer.natCode ? [isID(customer.natCode)] : []"
                ></v-text-field>
                <span
                  v-if="!checkCodeMeli(customer.natCode)"
                  class="red--text font-weight-bold"
                  style="font-size: 0.8rem"
                  >کد ملی وارد شده صحیح نمی‌باشد!</span
                >
              </v-col>
              <v-col cols="12">
                <!-- <v-text-field
                outlined
                dense
                label="تراز مالی"
                disabled
                v-model="customer.balance"
              ></v-text-field> --></v-col
              >
            </v-row>
          </v-card-text>

          <div class="text-left pb-3 pe-5">
            <v-btn
              class="red-borderedBtn"
              width="90"
              @click="customerDialog = false"
            >
              لغو
            </v-btn>
            <v-btn
              :loading="editLoading"
              class="purple-mainBtn ms-1"
              width="90"
              @click="editCustomer()"
              :disabled="
                !customer.name ||
                !customer.type ||
                !checkCodeMeli(customer.natCode)
              "
            >
              ثبت
            </v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="newCustomerDialog" width="600">
      <v-card class="shop-dialog">
        <v-card-title class="white">
          <v-row>
            <v-col>
              <h4 class="c-grey mb-0">ثبت مشتری جدید</h4>
            </v-col>
            <v-col class="text-left pt-2">
              <span class="pointer" @click="newCustomerDialog = false"
                ><v-icon class="close-icon">$Close</v-icon></span
              >
            </v-col>
          </v-row>
        </v-card-title>
        <hr class="mt-2 mb-8" />
        <v-card-text class="custom-input">
          <v-row>
            <v-col cols="12">
              <v-text-field
                placeholder="* نام و نام خانوادگی"
                outlined
                dense
                hide-details
                v-model="newCustomer.name"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-select
                attach
                class="shop-select"
                :menu-props="{ bottom: true, offsetY: true }"
                placeholder="* نوع مشتری"
                outlined
                dense
                type="number"
                :items="customerTypes"
                v-model="newCustomer.type"
                hide-details
              ></v-select>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                outlined
                dense
                placeholder="کد ملی"
                type="number"
                v-model="newCustomer.natCode"
                hide-details=""
                :rules="newCustomer.natCode ? [isID(newCustomer.natCode)] : []"
              ></v-text-field>
              <span
                v-if="!checkCodeMeli(newCustomer.natCode)"
                class="red--text font-weight-bold"
                style="font-size: 0.8rem"
                >کد ملی وارد شده صحیح نمی‌باشد!</span
              >
            </v-col>
            <v-col cols="12">
              <v-text-field
                placeholder="کد اقتصادی"
                outlined
                dense
                hide-details
                type="number"
                v-model="newCustomer.economicCode"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12">
              <v-text-field
                placeholder="شماره تلفن موبایل"
                outlined
                dense
                hide-details
                type="number"
                v-model="newCustomer.mobile"
              ></v-text-field>
              <div v-if="newCustomer.mobile">
                <phoneNumber :number="newCustomer.mobile" v-slot="{ isValid }">
                  <div
                    v-if="!isValid"
                    style="vertical-align: middle"
                    class="text--right"
                  >
                    <v-icon class="red--text me-1"
                      >mdi-alert-circle-outline</v-icon
                    >
                    <span class="red--text">شماره موبایل معتبر نیست</span>
                  </div>
                </phoneNumber>
              </div>
            </v-col>
            <v-col cols="12">
              <v-text-field
                placeholder="شماره تلفن ثابت"
                outlined
                dense
                hide-details
                type="number"
                v-model="newCustomer.phone"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <v-text-field
                placeholder="آدرس"
                outlined
                dense
                hide-details
                v-model="newCustomer.address"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>

        <div class="text-left py-3 pe-5">
          <v-btn
            class="red-borderedBtn ms-2 me-2"
            @click="newCustomerDialog = false"
            width="90"
          >
            لغو
          </v-btn>
          <v-btn
            @click="addCustomer()"
            :disabled="
              !newCustomer.name ||
              !newCustomer.type ||
              !checkCodeMeli(newCustomer.natCode)
            "
            class="purple-mainBtn white--text"
            width="90"
          >
            افزودن
          </v-btn>
        </div>
      </v-card>
    </v-dialog>

    <br />
    <router-view></router-view>
    <div id="printTable" v-show="false">
      <h3 class="text-right" style="float: right">لیست مشتریان</h3>
      <b-table :items="computedItems" :fields="printFields">
        <template v-slot:head()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.label }}
          </div>
        </template>
        <template v-slot:cell()="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.value }}
          </div>
        </template>
        <template v-slot:cell(index)="data">
          <div style="text-align: center; vertical-align: middle">
            {{ data.index + 1 }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import Axios from "axios";

function checkCodeMeli(code) {
  var L = code.length;
  if (L > 10) return false;
  if (L < 8 || parseInt(code, 10) == 0) return false;
  code = ("0000" + code).substr(L + 4 - 10);
  if (parseInt(code.substr(3, 6), 10) == 0) return false;
  var c = parseInt(code.substr(9, 1), 10);
  var s = 0;
  for (var i = 0; i < 9; i++) s += parseInt(code.substr(i, 1), 10) * (10 - i);
  s = s % 11;
  return (s < 2 && c == s) || (s >= 2 && c == 11 - s);
}
export default {
  data: function () {
    return {
      filter: "",
      perPageOptions: [4, 10, 20],
      fields: [
        { key: "index", label: "ردیف" },
        { key: "customerCode", label: "کد مشتری" },
        { key: "name", label: "نام مشتری" },
        { key: "type", label: "نوع مشتری" },
        { key: "mobile", label: "موبایل سازمانی" },
        // { key: "royaltyTier", label: "سطح‌بندی مشتری" },
        // { key: "royaltyCreditType", label: "اعتبار فعال" },
        { key: "operation", label: "عملیات" },
      ],
      printFields: [
        { key: "index", label: "ردیف" },
        { key: "customerCode", label: "کد مشتری" },
        { key: "name", label: "نام مشتری" },
        { key: "type", label: "نوع مشتری" },
        { key: "mobile", label: "موبایل سازمانی" },
      ],
      excelFields: [
        { field: "customerCode", label: "کد مشتری" },
        { field: "name", label: "نام مشتری" },
        { field: "type", label: "نوع مشتری" },
        { field: "mobile", label: "موبایل سازمانی" },
      ],
      customerTypes: [
        { value: "naturalPerson", text: "حقیقی" },
        { value: "legalPerson", text: "حقوقی" },
      ],
      customerEmail: "",
      customerDialog: false,
      userInput: "",
      currentPage: 1,
      perPage: 10,
      TotalRows: 1,
      striped: true,
      selectedCustomer: {},
      isBusy: true,
      customers: [],
      selected: "",
      newCustomerDialog: false,
      newCustomer: {},
      loading: false,
      cardLoading: false,
      customer: {},
      editLoading: false,
    };
  },

  methods: {
    isID(id) {
      // NOTE (m-isID) to check the validity of the national code
      return id ? (checkCodeMeli(id) ? true : false) : false;
    },
    // computedIcon(item) {
    //   if (item.royaltyTier == "coper") {
    //     return "/icons8-star-35(1).png";
    //   } else if (item.royaltyTier == "silver") {
    //     return "/icons8-star-35.png";
    //   } else if (item.royaltyTier == "gold") {
    //     return "/icons8-star-35(2).png";
    //   } else if (item.royaltyTier == "diamond") {
    //     return "/icons8-diamond-35.png";
    //   }
    // },
    showNewCustomerDialog() {
      this.newCustomer = {};
      this.newCustomerDialog = true;
    },
    addCustomer() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/new",
        {
          name: this.newCustomer.name,
          mobile: this.newCustomer.mobile,
          economicCode: this.newCustomer.economicCode,
          phone: this.newCustomer.phone,
          address: this.newCustomer.address,
          natCode: this.newCustomer.natCode,
          type: this.newCustomer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.loading = false;
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newCustomer = {};
            this.newCustomerDialog = false;
            this.showCustomers();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.loading = false;
        });
    },
    editCustomer() {
      this.editLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/edit",
        {
          shopCustomerId: this.selected,
          name: this.customer.name,
          mobile: this.customer.mobile,
          economicCode: this.customer.economicCode,
          phone: this.customer.phone,
          address: this.customer.address,
          natCode: this.customer.natCode,
          type: this.customer.type,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.editLoading = false;
          if (res.status == 200) {
            this.toast(res.data, "success");
            this.customerDialog = false;
            this.isBusy = true;
            this.showCustomers();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.customerDialog = false;
          }
        })
        .catch((err) => {
          this.editLoading = false;
          this.toast(err.response.data, "error");
          this.isBusy = false;
        });
    },
    getCustomerInfo() {
      this.loading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customer/getInfo",
        {
          shopCustomerId: this.selected,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.customer = res.data;
            this.loading = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          console.log(err);
          this.toast(err.response.data, "error");
        });
    },
    showCustomerDialog(customer) {
      this.customerDialog = true;
      this.selected = customer;
      this.getCustomerInfo();
    },
    showCustomers() {
      this.cardLoading = true;
      Axios.post(
        this.baseUrl + "/ppkpms/shop/customers/getAll",
        {},
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          this.cardLoading = false;
          if (res.status == 200) {
            this.customers = res.data;
            this.TotalRows = this.customers.length;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.cardLoading = false;
        });
    },
    printReceipt() {
      //printing receipt
      var myWindow = window.open("#", "printTable", "height=auto,width=800");
      myWindow.document.write(
        "<html><head><style>body{font-size: 16px;font-family:B Nazanin;} table, td, th {border: 1px solid black} tr{ page-break-inside:avoid; page-break-after:auto } thead { display: table-header-group;} table{border-collapse: collapse; direction: rtl; font-size:16px; width:100%}</style><title> </title>"
      );
      myWindow.document.write("</head><body>");
      myWindow.document.write(document.getElementById("printTable").innerHTML);
      myWindow.document.write("</body></html>");
      myWindow.document.close();

      myWindow.onload = function () {
        myWindow.focus();
        myWindow.print();
        myWindow.close();
      };
    },
  },

  computed: {
    computedItems() {
      let filtered;
      filtered = this.customers.filter(
        (x) =>
          x.name.toLowerCase().includes(this.filter) ||
          x.customerCode.toLowerCase().includes(this.filter) ||
          x.type.toLowerCase().includes(this.filter) ||
          x.mobile.toLowerCase().includes(this.filter)
      );

      return filtered;
    },
  },
  mounted() {
    this.showCustomers();
  },
};
</script>

<style lang="scss">
* {
  font-family: iransans;
}
@font-face {
  font-family: iransans;
  src: url("../../assets/fonts/IRANSans(FaNum).ttf");
}
.custom-input {
  .v-input__slot {
    border-radius: 8px !important;
    width: 100% !important;
  }
}
</style>
